export const LOGIN_SUCCESS="LOGIN_SUCCESS"
export const LOGIN_FAILURE="LOGIN_FAILURE"
export const LOGIN_REQUEST="LOGIN_REQUEST"